import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  signal,
} from '@angular/core';
import { type Field, FormField } from '@angular/forms/signals';
import {
  LucideDynamicIcon,
  LucideEye,
  LucideEyeOff,
  LucideLock,
  provideLucideIcons,
} from '@lucide/angular';
import { TranslateModule } from '@ngx-translate/core';
import { FormErrors } from '@shared/components/form-errors/form-errors';

@Component({
  selector: 'app-password-field',
  standalone: true,
  imports: [
    FormField,
    LucideDynamicIcon,
    LucideLock,
    TranslateModule,
    FormErrors,
  ],
  providers: [provideLucideIcons(LucideEye, LucideEyeOff)],
  templateUrl: './password-field.component.html',
  styleUrl: './password-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PasswordFieldComponent {
  /** ID cho input (cần unique trên page) */
  readonly fieldId = input.required<string>();

  /** Translation key cho label, ví dụ 'COMMON.PASSWORD' */
  readonly label = input<string>();

  /** Translation key cho placeholder */
  readonly placeholder = input.required<string>();

  /** Field accessor từ Signal Form, ví dụ loginForm.password */
  readonly field = input.required<Field<string>>();

  /** Hiện icon ổ khóa bên trái (mặc định = false) */
  readonly showPrefixIcon = input(false);

  /** CSS class cho wrapper ngoài cùng, ví dụ 'mb-4' hoặc 'mb-0' */
  readonly wrapperClass = input('mb-3');

  /** Hiện dấu * required (mặc định = true) */
  readonly required = input(true);

  /** Autocomplete attribute for the input (default = 'off') */
  readonly autocomplete = input<string>('off');

  // --- Internal toggle state ---
  readonly showPassword = signal(false);

  readonly passwordIcon = computed(() =>
    this.showPassword() ? LucideEyeOff : LucideEye,
  );

  toggleVisibility(): void {
    this.showPassword.update((v) => !v);
  }
}
